var _defs, _path, _path2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackward5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "allergies",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 32px;\n      }\n\n      .cls-2 {\n        font-family: GalGothicVariableRoman-Extrabold, 'Gal Gothic Variable';\n        font-size: 312.04px;\n        font-variation-settings: 'wght' 800;\n        font-weight: 700;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.74,37.38l46.83,67.03c3.47,4.97.3,11.84-5.74,12.42l-86.31,8.26c-6.26.6-10.69-5.99-7.77-11.56l39.48-75.29c2.76-5.26,10.11-5.73,13.51-.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.06,80.24c38.03-31.38,86.78-50.24,139.94-50.24,121.5,0,220,98.5,220,220s-98.5,220-220,220S31,371.5,31,250"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(161.05 350.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward5);
export default __webpack_public_path__ + "static/media/backward-5.53666e0fb307d3d1c19f8d94ba75bcaf.svg";
export { ForwardRef as ReactComponent };